<div class="cads-radio-group" [class.cads-radio-group--error]="_hasError()">
  @if (config().label) {
    <span [id]="_groupLabelId()" class="cads-radio-group__label" [class.cads-radio-group__label--error]="_hasError()">
      {{ config().label }}
      @if (config().required) {
        <span class="cads-radio-group__required" aria-hidden="true">*</span>
      }
    </span>
  }
  <div class="cads-radio-group__rows">
    @for (option of config().options; track option.id) {
      <label
        class="cads-radio-group__option"
        [class.cads-radio-group__option--selected]="_isSelected(option)"
        [class.cads-radio-group__option--disabled]="_isDisabled(option)"
        [class.cads-radio-group__option--bare]="!_cardStyle(option)"
        [class.cads-radio-group__option--error]="_hasError()"
        [attr.for]="_rowInputId(option)"
      >
        <input
          class="cads-radio-group__input"
          type="radio"
          [name]="_groupId()"
          [id]="_rowInputId(option)"
          [value]="option.id"
          [checked]="_isSelected(option)"
          [disabled]="_isDisabled(option)"
          [attr.aria-label]="option.label"
          (change)="_onRowChange(option, $event)"
        />
        <span class="cads-radio-group__indicator" aria-hidden="true">
          <span class="cads-radio-group__radio" [class.cads-radio-group__radio--checked]="_isSelected(option)">
            @if (_isSelected(option)) {
              <span class="cads-radio-group__radio-dot"></span>
            }
          </span>
        </span>
        <span class="cads-radio-group__body">
          @if (_heading(option); as h) {
            <cads-heading-detail-bit [config]="h" />
          } @else {
            @if (_subtitleOnly(option); as sub) {
              <span class="cads-radio-group__subtitle-only">{{ sub }}</span>
            } @else {
              <span class="cads-radio-group__row-label">{{ option.label }}</span>
            }
          }
        </span>
      </label>
    }
  </div>
  @if (_showCaption()) {
    <p
      [id]="_captionId()"
      class="cads-radio-group__caption"
      [class.cads-radio-group__caption--error]="_hasError()"
      [attr.role]="_hasError() ? 'alert' : null"
    >
      {{ _captionText() }}
    </p>
  }
</div>
